import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import {
    Button,
    Breadcrumb,
    Grid, Form, Header, Checkbox
} from 'semantic-ui-react';
import update from 'react-addons-update';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import CustomDivider from '../../components/extras/CustomDivider';
import DeliveryData from "../../data/DeliveryData";
import connect from "react-redux/es/connect/connect";
import { showToast } from "../../actions/ToastAction";
import Loading from "../../components/extras/Loading";
import CheckPermission from "../../components/extras/CheckPermission";

const moneyMask = createNumberMask({
    prefix: '$',
});

class Delivery extends Component {
    constructor() {
        super();
        this.state = {
            data: {
                has_delivery: false,
                delivery_price: 0,
                has_free_delivery: true,
                has_free_delivery_for: false,
                free_delivery_for: 0
            },
            loading: true,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeToggle = this.handleChangeToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    handleChangeToggle = (e, { checked, name }) => {
        let data = update(this.state, {
            data: {
                [name]: { $set: checked }
            }
        });
        this.setState(data);
    }

    handleChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '' : parseFloat(event.target.value.replace(/\D/g, ''));
        let data = update(this.state, {
            data: {
                [event.target.name]: { $set: value }
            }
        });
        this.setState(data);
    };

    initialFetch() {
        DeliveryData.get(res => {
            let data = {
                has_delivery: res.has_delivery,
                delivery_price: res.delivery_price,
                has_free_delivery: res.has_free_delivery,
                has_free_delivery_for: res.has_free_delivery_for,
                free_delivery_for: res.free_delivery_for
            };
            this.setState({ data, loading: false });
        });
    };

    async handleSubmit(event) {
        event.preventDefault();
        let data = this.state.data;
        data.delivery_price = typeof data.delivery_price === 'number' ? data.delivery_price : 0;
        data.free_delivery_for = typeof data.free_delivery_for === 'number' ? data.free_delivery_for : 0;
        this.setState({ disabled_button: true });
        DeliveryData.update(this.state.data, (res) => {
            if (res.update) {
                this.props.showToast({ message: 'Información Actualizada!', type: 'success' });
            } else {
                this.props.showToast({ message: 'Tenemos un problema, inténtalo más tarde!', type: 'error' });
            }
            this.setState({ disabled_button: false });
        });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Mi Sitio Web | Domicilios - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/services'>Servicios</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section active>Domicilios</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider />
                <Header as='h2'>
                    <Header.Content>
                        Configuración para Domicilios
                    </Header.Content>
                </Header>
                <br />
                {!this.state.loading ?
                    <Grid>
                        <Grid.Row>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Field>
                                        <label>¿Ofrece servicio de domicilios?</label>
                                        <Checkbox
                                            name='has_delivery'
                                            toggle
                                            checked={this.state.data.has_delivery}
                                            label={`${this.state.data.has_delivery ? 'Si' : 'No'}`}
                                            onChange={this.handleChangeToggle}
                                        />
                                    </Form.Field>
                                    {this.state.data.has_delivery ?
                                        <Form.Field>
                                            <label>¿Ofrece domicilios gratis?</label>
                                            <Checkbox
                                                name='has_free_delivery'
                                                toggle
                                                checked={this.state.data.has_free_delivery}
                                                label={`${this.state.data.has_free_delivery ? 'Si' : 'No'}`}
                                                onChange={this.handleChangeToggle}
                                            />
                                        </Form.Field> : null}
                                    {this.state.data.has_delivery && !this.state.data.has_free_delivery ?
                                        <Form.Input
                                            label='Valor domicilio'
                                            name='delivery_price'
                                            children={
                                                <MaskedInput
                                                    autoFocus
                                                    value={this.state.data.delivery_price}
                                                    mask={moneyMask}
                                                    name='delivery_price'
                                                    placeholder='Valor domicilio'
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        /> : null}
                                    {this.state.data.has_delivery && !this.state.data.has_free_delivery ?
                                        <Form.Field>
                                            <label>¿Ofrece domicilios gratis para compras superiores o iguales a?</label>
                                            <Checkbox
                                                name='has_free_delivery_for'
                                                toggle
                                                checked={this.state.data.has_free_delivery_for}
                                                label={`${this.state.data.has_free_delivery_for ? 'Si' : 'No'}`}
                                                onChange={this.handleChangeToggle}
                                            />
                                        </Form.Field> : null}
                                    {this.state.data.has_delivery && !this.state.data.has_free_delivery && this.state.data.has_free_delivery_for ?
                                        <Form.Input
                                            label='Valor'
                                            children={
                                                <MaskedInput
                                                    autoFocus
                                                    name='free_delivery_for'
                                                    value={this.state.data.free_delivery_for} 
                                                    mask={moneyMask}
                                                    placeholder='Valor'
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        /> : null}
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Button primary fluid disabled={this.state.disabled_button} loading={this.state.disabled_button}
                                                type="submit" content="Actualizar Información" />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    : <Grid.Row centered><Loading /></Grid.Row>}
                <CheckPermission access='website_edit' />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(toast) {
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Delivery)


// WEBPACK FOOTER //
// ./src/containers/settings/Delivery.js